import React, { useEffect } from 'react';
import { Script } from 'gatsby';
import { useSelector } from 'react-redux';
import { RootState } from '../../../state/Store';
import { DashboardNavbar } from './dashboard-navbar';
import { DashboardTopNav } from './dashboard-top-nav';
import { DashboardFooter } from './dashboard-footer';
import { ContentBackground } from './content-background';

import './dashboard-layout.scss';

interface IProps {
  children: React.ReactNode;
  className?: string;
  game: string;
}

export const DashboardLayout: React.FC<IProps> = (props) => {
  const model = useSelector((state: RootState) => ({
    layout: state.layout
  }));

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const fusetag = window.fusetag || (window.fusetag = { que: [] });

      fusetag.que.push(function () {
        fusetag.pageInit();
        fusetag.registerAll();
      });
    }
  });

  return (
    <div
      className={`game-layout-wrapper ${
        model.layout.isSideMenuExtended ? 'expanded' : 'minimal'
      } ${props.className}`}
    >
      <Script
        async
        src="https://cdn.fuseplatform.net/publift/tags/2/2953/fuse.js"
      />
      <DashboardNavbar game={props.game} />
      <div className="right-main">
        <DashboardTopNav game={props.game} />
        <div className={`content ${props.game}`}>
          <ContentBackground game={props.game} />
          {props.children}
          <DashboardFooter />
        </div>
      </div>
    </div>
  );
};
